// removed by extract-text-webpack-plugin
module.exports = {"widget":"index__widget___1u3vM","iconBtn":"index__iconBtn___1V9Cn","icon":"index__icon___1oDwZ","bubble":"index__bubble___19Usn","closeBtn":"index__closeBtn___jP6Wn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/molecules/ChatbotWidget/index.css
// module id = 767
// module chunks = 12